'use client';

import { signIn } from '@repo/auth';
import { RainbowButton, toast } from '@repo/ui';
import { Fingerprint, Loader2 } from 'lucide-react';
import * as React from 'react';

async function signInWithPasskey(): Promise<void> {
  const result = await signIn.passkey();

  if (result.error) {
    throw new Error(result.error.message || 'Passkey sign-in failed');
  }

  window.location.href = '/';
}

interface IPasskeyLoginButtonProps {
  onStart?: () => void;
}

export function PasskeyLoginButton({ onStart }: IPasskeyLoginButtonProps): React.ReactNode {
  const [isLoading, setIsLoading] = React.useState(false);

  const handlePasskeyLogin = (): void => {
    onStart?.();
    setIsLoading(true);

    const signInPromise = signInWithPasskey();

    toast.promise(signInPromise, {
      loading: 'Signing in...',
      success: 'Redirecting...',
      error: (err: Error) => {
        setIsLoading(false);
        const message = err.message || 'Failed to sign in with passkey';

        if (message.includes('cancelled') || message.includes('canceled')) {
          return 'Sign in cancelled';
        }

        return message;
      },
    });
  };

  return (
    <RainbowButton
      type="button"
      variant="outline"
      size="lg"
      className="w-full max-w-xs gap-2"
      onClick={handlePasskeyLogin}
      disabled={isLoading}
    >
      {isLoading ? (
        <Loader2 className="size-4 shrink-0 animate-spin" aria-hidden="true" />
      ) : (
        <Fingerprint className="size-4 shrink-0" aria-hidden="true" />
      )}
      Sign in with Passkey
    </RainbowButton>
  );
}
